import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing, color } from '@metro-ui/tokens/js';
export var TabPanel = styled(function (_a) {
    var name = _a.name, isActive = _a.isActive, shouldRenderOnlyActive = _a.shouldRenderOnlyActive, shouldEscapePadding = _a.shouldEscapePadding, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["name", "isActive", "shouldRenderOnlyActive", "shouldEscapePadding", "className", "children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { className: className, hidden: !isActive, role: "tabpanel" }), ((shouldRenderOnlyActive && isActive) || !shouldRenderOnlyActive) &&
        children));
})(function (_a) {
    var isActive = _a.isActive, shouldEscapePadding = _a.shouldEscapePadding;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    border-top: 1px solid ", ";\n\n    ", "\n\n    ", "\n  "])), color.palette.grey.tint[80], !shouldEscapePadding && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), spacing.large), !isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "]))));
});
TabPanel.propTypes = {
    name: PropTypes.string,
    isActive: PropTypes.bool,
    shouldEscapePadding: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TabPanel.js.map